const SALESREP_LOADING_KEYS: Readonly<Record<string, string>> = {
  '/add-new-customer': 'core.loading.form',
  '/customer-details': 'core.loading.customer',
};

const MODULE_LOADING_KEYS: Readonly<Record<string, string>> = {
  '/warehouse-orders': 'core.loading.warehouse',
  '/procurement': 'core.loading.procurement',
  '/expenses': 'core.loading.expenses',
  '/timesheets': 'core.loading.timesheets',
  '/users-management': 'core.loading.settings',
  '/organization-admin': 'core.loading.organizationAdmin',
  '/profile': 'core.loading.profile',
  '/account': 'core.loading.account',
};

function mappedLoadingKey(url: string, routes: Readonly<Record<string, string>>): string | undefined {
  return Object.entries(routes).find(([route]) => url.includes(route))?.[1];
}

export function loadingMessageKeyForRoute(url: string): string {
  if (url.includes('/salesrep')) {
    if (url.match(/\/customer-details\/[^/]+$/) && url.split('/').length > 6) return 'core.loading.order';
    return mappedLoadingKey(url, SALESREP_LOADING_KEYS) ?? 'core.loading.salesrep';
  }

  return mappedLoadingKey(url, MODULE_LOADING_KEYS) ?? 'core.loading.default';
}
